export const APP_CONFIG = {
  NAME: import.meta.env.VITE_APP_NAME || 'AI Creative Studio',
  MAX_MESSAGE_LENGTH: parseInt(import.meta.env.VITE_MAX_MESSAGE_LENGTH || '500', 10),
  USE_FALLBACK: import.meta.env.VITE_USE_FALLBACK === 'true',
} as const;

export const AI_CONFIG = {
  OPENAI: {
    API_KEY: import.meta.env.VITE_OPENAI_API_KEY,
    MODEL: import.meta.env.VITE_OPENAI_MODEL || 'gpt-3.5-turbo',
    ENDPOINT: 'https://api.openai.com/v1/chat/completions',
  },
  GROK: {
    API_KEY: import.meta.env.VITE_GROK_API_KEY,
    ENDPOINT: 'https://api.x.ai/v1/chat/completions',
    MODEL: 'grok-beta',
  },
} as const;

export const TTS_CONFIG = {
  DEFAULT_RATE: 1.0,
  DEFAULT_PITCH: 1.0,
  DEFAULT_VOLUME: 1.0,
  PREFERRED_VOICES: ['Google US English', 'Microsoft Zira', 'Samantha', 'Alex'],
} as const;

export const ANIMATION_CONFIG = {
  MOUTH_OPEN_DURATION: 120, // ms
  MOUTH_CLOSE_DURATION: 80, // ms
  BLINK_DURATION: 150, // ms
  BLINK_INTERVAL_MIN: 3000, // ms
  BLINK_INTERVAL_MAX: 7000, // ms
  EXPRESSION_TRANSITION: 0.3, // seconds
} as const;

export const RATE_LIMIT_CONFIG = {
  MAX_RETRIES: 3,
  MIN_REQUEST_INTERVAL: 1000, // 1 second between requests
  INITIAL_BACKOFF: 1000, // Start with 1 second
  MAX_BACKOFF: 10000, // Cap at 10 seconds
} as const;

export const ERROR_MESSAGES = {
  API_ERROR: "I'm having trouble connecting. Please try again.",
  NETWORK_ERROR: 'Network error. Please check your connection.',
  INVALID_INPUT: 'Please enter a valid message.',
  MESSAGE_TOO_LONG: `Message is too long. Maximum ${APP_CONFIG.MAX_MESSAGE_LENGTH} characters.`,
  TTS_ERROR: 'Unable to play audio. Your browser may not support text-to-speech.',
  GENERIC_ERROR: 'Something went wrong. Please try again.',
  RATE_LIMIT: "I'm experiencing high traffic. Please wait a moment and try again.",
} as const;

export const FALLBACK_RESPONSES = [
  "That's interesting! Tell me more.",
  'I understand. How does that make you feel?',
  "That's a great question! Let me think about that.",
  'I see what you mean. Can you elaborate?',
  "That's fascinating! What else can you tell me?",
  'I appreciate you sharing that with me.',
  "That's worth considering. What are your thoughts?",
  "Interesting perspective! I'd love to hear more.",
  "I'm here to listen. Please continue.",
  "That's something to think about. What do you think?",
] as const;

export const GREETINGS = [
  'hello',
  'hi',
  'hey',
  'greetings',
  'good morning',
  'good afternoon',
  'good evening',
] as const;

export const GREETING_RESPONSES = [
  "Hello! I'm your AI assistant. How can I help you today?",
  'Hi there! Great to see you. What can I do for you?',
  "Hey! I'm here to chat. What's on your mind?",
  "Greetings! I'm ready to assist you. What would you like to talk about?",
] as const;
